// LICENSE_CODE ZON
 /*jslint browser:true, es6:true, node:true, react:true*/
import React, {CSSProperties, useEffect, useRef, useState} from 'react';
import {Link, useLocation} from 'react-router-dom';
import cn from 'classnames';
import {Button} from '../../lib/button';
import {guess_browser} from 'zuser_agent';
import * as ui_links from '../ui_install_links';
import {use_theme} from '../../settings_ctx';
import Icon_user_circle from '../../img/hola2023/icons/24/user_circle.svg';
import Icon_cart from '../../img/hola2023/icons/24/cart.svg';
import Icon_log_out from '../../img/hola2023/icons/16/log_out.svg';
import Icon_chevron_right from '../../img/hola2023/icons/16/chevron_right.svg';
import {logout} from './nav_utils';
import styles from './nav_user.module.less';
import {use_qs_with_set} from '../../lib/use_qs';
import {use_login} from './use_login';

interface i_user_links_props {
    has_ext?: boolean;
    cp_after_login?: boolean;
    cp_link?: string;
    no_getstarted?: boolean;
    cp_always_icon?: boolean;
}
const User_links = (props: i_user_links_props)=>{
    const {has_ext, no_getstarted} = props;
    const {theme} = use_theme({def: 'hola2023'});
    const [shift, set_shift] = useState<number>(0);
    const {state} = useLocation();
    const start_ref = useRef<HTMLDivElement>();
    const b = guess_browser();
    const {on_login, show_login_form} = use_login(
        props.cp_after_login, props.cp_link);
    const on_start = ()=>{
        location.href = ui_links[`${b.browser}_href`]||ui_links.chrome_href;
        return;
    };
    useEffect(()=>{
        if (start_ref.current)
        {
            const w = start_ref.current.offsetWidth;
            set_shift(w);
        }
    }, [start_ref.current]);
    useEffect(()=>{
        if ((state as object_of<boolean>)?.need_login)
            show_login_form();
    }, [state]);
    return <div className={cn(styles.user_links,
      !no_getstarted && has_ext && styles.ext)}>
      <a style={{'--shift': `${shift}px`} as CSSProperties}
        className={cn(theme.u4, styles.login,
          props.cp_always_icon && styles.icon_login)} onClick={on_login}
        data-clickid="nav_login">{props.cp_always_icon ? <Icon_user_circle/>
        : 'Log in'}</a>
      {!no_getstarted && !has_ext &&
        <div ref={start_ref} className={styles.start}>
          <Button txt_colored size="xs" caption="Get started"
            on_click={on_start} clickid="nav_start"/>
        </div>}
    </div>;
};

const User_menu = ({cp_link})=>{
    const {theme} = use_theme({def: 'hola2023'});
    const on_logout = event=>{
        event.preventDefault();
        logout();
    };
    return <div className={styles.user_menu}>
      <div className={styles.profile}><Icon_user_circle/></div>
      <div className={styles.links}>
        <ul>
          <li><Link to={cp_link||'/cp'} data-clickid="nav_account">
            <span className={cn(theme.P, theme.p4, theme.med)}>
              My account
            </span><Icon_chevron_right/>
          </Link></li>
          <li><a onClick={on_logout} data-clickid="nav_logout">
            <span className={cn(theme.P, theme.p4, theme.med)}>
              Log out
            </span><Icon_log_out/>
          </a></li>
        </ul>
      </div>
    </div>;
};

interface i_nav_user_props {
    has_user?: boolean;
    is_scrolled?: boolean;
    has_ext?: boolean;
    cp_after_login?: boolean;
    cp_always_icon?: boolean;
    cp_link?: string;
    with_cart?: boolean;
    no_getstarted?: boolean;
}
export const Nav_user = (props: i_nav_user_props)=>{
    const {has_user, is_scrolled, has_ext, cp_link, cp_after_login,
      with_cart, no_getstarted, cp_always_icon} = props;
    const cls = cn(styles.nav_user, is_scrolled && styles.scrolled);
    const {set_qs} = use_qs_with_set();
    return <div className={cls}>
      {has_user ? <User_menu cp_link={cp_link}/>
        : <User_links has_ext={has_ext} cp_link={cp_link}
          cp_after_login={cp_after_login}
          cp_always_icon={cp_always_icon}
          no_getstarted={no_getstarted}/>}
      {with_cart && <div className={styles.cart_icon}>
        <Icon_cart onClick={()=>{
          set_qs({with_cart: 'true'});
        }}/>
      </div>}
    </div>;
};
